export class ConsultationDiagnosisIcd10 {
    codes: string[];
    other: string;

    static getDefaultValue(): ConsultationDiagnosisIcd10 {
        return {
            codes: [],
            other: '',
        };
    }

    static normalize(value?: Partial<ConsultationDiagnosisIcd10> | null): ConsultationDiagnosisIcd10 {
        return {
            codes: Array.isArray(value?.codes) ? value.codes.filter((x) => typeof x === 'string' && x.trim()) : [],
            other: typeof value?.other === 'string' ? value.other : '',
        };
    }

    static isFilled(value?: Partial<ConsultationDiagnosisIcd10> | null): boolean {
        const normalized = ConsultationDiagnosisIcd10.normalize(value);
        return normalized.codes.length > 0 || !!normalized.other.trim();
    }
}
